<template>
  <!-- vue-loader 要求单根节点；display:contents 避免多包一层影响布局 -->
  <div class="t4-wrap">
    <!-- Elementor 前端用 #elementor-device-mode 伪元素判断断点，与原生站 DOM 对齐 -->
    <span id="elementor-device-mode"
          class="elementor-screen-only"
          aria-hidden="true"></span>
    <HomeType4Content :homeInfo="homeInfo"
                      :expertConfig="expertConfig" />
  </div>
</template>

<script>
/** 样式仅在 type4 入口引入，不修改 main.js / vue.config */
import './type4-all.js'
import HomeType4Content from './components/HomeType4Content.vue'

/** Jet Engine 等样式依赖 body[data-elementor-device-mode]，与 WP body 行为对齐 */
const BODY_MARK = 'data-elementor-device-mode'
const BODY_CLASS_WP = ['elementor-default', 'elementor-page']
/** apple-webkit.min.css 中 WebKit 专用规则依赖 html.e--ua-appleWebkit，原站由 Elementor 前端脚本写入 */
const HTML_UA_WEBKIT = 'e--ua-appleWebkit'

export default {
  name: 'HomeType4Page',

  components: {
    HomeType4Content,
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({}),
    },

    expertConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      prevDeviceMode: null,
      addedHtmlUaWebkit: false
    }
  },

  mounted() {
    this.prevDeviceMode = document.body.getAttribute(BODY_MARK)
    document.body.setAttribute(BODY_MARK, 'desktop')
    BODY_CLASS_WP.forEach((c) => document.body.classList.add(c))

    // Safari / 非 Chrome 的 WebKit：为 html 补类名，使社交图标等选择器与 WP 一致
    const ua = navigator.userAgent
    const isNonChromeWebKit = /AppleWebKit/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Brave|CriOS/i.test(ua)
    const rootEl = document.documentElement
    if (isNonChromeWebKit && !rootEl.classList.contains(HTML_UA_WEBKIT)) {
      rootEl.classList.add(HTML_UA_WEBKIT)
      this.addedHtmlUaWebkit = true
    }
  },

  beforeDestroy() {
    BODY_CLASS_WP.forEach((c) => document.body.classList.remove(c))
    if (this.prevDeviceMode === null) {
      document.body.removeAttribute(BODY_MARK)
    } else {
      document.body.setAttribute(BODY_MARK, this.prevDeviceMode)
    }
    if (this.addedHtmlUaWebkit) {
      document.documentElement.classList.remove(HTML_UA_WEBKIT)
    }
  },
}
</script>

<style scoped>
/* 避免 display:contents 在部分浏览器下影响子树样式与层叠，用普通块级容器 */
.t4-wrap {
  display: block;
  width: 100%;
}
</style>
